var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from "@http";
import { action, runInAction } from "mobx";
import Cookies from "js-cookie";
import { isIH, isWPH, setLocationId } from "@common/utils";
import { AbFeatures, hasAbFeature } from "@common/utils/abFeature";
var ShareStore = /** @class */ (function () {
    function ShareStore() {
    }
    ShareStore.prototype.getClientId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Cookies.get('clientId')) {
                            this.beforeGetToggle(Cookies.get('clientId'));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api().getClientId()];
                    case 1:
                        promise = _a.sent();
                        return [4 /*yield*/, promise];
                    case 2:
                        data = _a.sent();
                        Cookies.set('clientId', data);
                        this.beforeGetToggle(data);
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    ShareStore.prototype.reGetClientId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getClientId();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        Cookies.set('clientId', data);
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    ShareStore.prototype.beforeGetToggle = function (clientId) {
        this.getDisableMenuBarToggle(clientId);
    };
    ShareStore.prototype.isAutoScheduleRegion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Cookies.get('isAutoScheduleRegion')) {
                            return [2 /*return*/];
                        }
                        if (!Cookies.get('clientId')) {
                            this.getClientId().then(function (data) {
                                _this.isAutoScheduleRegion();
                            });
                            return [2 /*return*/];
                        }
                        if (!(isIH() || isWPH() && !hasAbFeature(AbFeatures.AutoSchedule))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api().isAutoScheduleRegion()];
                    case 1:
                        data = _a.sent();
                        Cookies.set('isAutoScheduleRegion', data ? String(data) : '');
                        return [2 /*return*/];
                    case 2:
                        Cookies.set('isAutoScheduleRegion', '');
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareStore.prototype.getDisableMenuBarToggle = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getDisableMenuBarToggle({ clientId: clientId });
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            Cookies.set('disableMenuBar', (data === true).toString());
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareStore.prototype.getLocationResidential = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getLocationResidential();
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            data && setLocationId(data.LocationId);
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    ShareStore.prototype.api = function () {
        return {
            getClientId: function () {
                return Q(http.get('/DRSP/Dashboard/GetClientId'));
            },
            isAutoScheduleRegion: function () {
                return Q(http.get('/RSP/NewRequest/IsAutoScheduleRegion'));
            },
            getDisableMenuBarToggle: function (params) {
                return Q(http.get("/RSP/Dashboard/DisableMenuBar?clientId=" + params.clientId));
            },
            getLocationResidential: function () {
                return Q(http.get("RSP/Dashboard/GetLocationResidential"));
            },
        };
    };
    __decorate([
        action
    ], ShareStore.prototype, "getClientId", null);
    __decorate([
        action.bound
    ], ShareStore.prototype, "reGetClientId", null);
    __decorate([
        action
    ], ShareStore.prototype, "beforeGetToggle", null);
    __decorate([
        action
    ], ShareStore.prototype, "isAutoScheduleRegion", null);
    __decorate([
        action
    ], ShareStore.prototype, "getLocationResidential", null);
    return ShareStore;
}());
export default ShareStore;
